import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getAllCosecha_pallets() {
    const Cosechas_palletsDB =  [];
    //console.log(valor);
    console.log("Hola");
    const collectionRef = collection(db, "Almacen_empaque/Cosecha/Productos/".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      Cosechas_palletsDB.push(doc.data());
    });
    return Cosechas_palletsDB;
    

}
